import React from 'react';
import { useTranslation } from 'react-i18next';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AddModelButton, DataTable, DeleteModelButton, GetContentButton, Panel, Toolbar } from '@lib/ui-components';
import { CompanyViewModel } from '@lib/api-interface';

export interface ClientOtherFilesProps {
  company: CompanyViewModel;
}

export function ClientOtherFiles(props: ClientOtherFilesProps) {
  const [tableReloadKey, setTableReloadKey] = React.useState(1);
  const { t } = useTranslation();

  return (
    <Panel borderType='none'>
      <Toolbar
        right={[
          <AddModelButton
            multipart={true}
            buttonLabel={t('uploadFile')}
            dialogTitle={t('uploadFile')}
            modelName={'companyFileViews'}
            fields={[
              {
                label: t('branch'),
                type: 'table-select',
                field: 'companyBranchId',
                tableSelectParams: {
                  modelName: 'companyBranchViews',
                  dialogTitle: t('branch'),
                  displayFormat: '{name}',
                  selectedValueField: 'branchId',
                  columns: [{ key: 'name', label: t('Model.CompanyBranch.name'), type: 'text' }],
                  fetchFilters: { companyId: props.company.companyId },
                },
              },
              { label: t('dragAndDropAFile'), type: 'file', field: 'content' },
              { label: t('comment'), type: 'text', field: 'comment' },
            ]}
            hiddenValues={{ type: 'OTHER', companyId: props.company.companyId }}
            onSaved={async () => setTableReloadKey(tableReloadKey + 1)}
          />,
        ]}
      />
      <DataTable
        refreshKey={tableReloadKey}
        modelDef={{ modelName: 'companyFileViews' }}
        fetchFilters={{ companyId: props.company.companyId, type: 'OTHER' }}
        columns={[
          {
            key: 'fileName',
            label: t('file'),
            type: 'text',
          },
          {
            key: 'companyBranch.name',
            label: t('Model.CompanyBranch.name'),
            type: 'text',
          },
          {
            key: 'companyBranch.registrationAddress.town',
            label: t('locality'),
            type: 'text',
          },
          {
            key: 'companyBranch.registrationAddress.street',
            label: t('street'),
            type: 'text',
          },
          {
            key: 'comment',
            label: t('comment'),
            type: 'text',
          },
        ]}
        rowOptions={[
          {
            renderer: (row) => <GetContentButton label={t('viewFile')} icon={<VisibilityIcon />} resourcePath={`api/resource/companyFileViews/${row.id}/content`} />,
          },
          {
            renderer: (row) => <DeleteModelButton modelName={'companyFileViews'} id={row.id} onDeleted={async () => setTableReloadKey(tableReloadKey + 1)} />,
          },
        ]}
      />
    </Panel>
  );
}
